var _style, _path, _g, _defs, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPastryProducts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B92555;}\n\t.st1{fill:#F29014;}\n\t.st2{clip-path:url(#SVGID_2_);fill:#D9780F;}\n\t.st3{fill:#F8AA36;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.31,185.55c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C27.01,151.26,61.62,185.55,104.31,185.55"
  })), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.25,158.32c-5.73-1.62-13.81-10.59-17.67-18.88c-0.47-1.01-2.84-1.74-3.26-2.8 c-6.42-16.02-7.23-37.24,7.46-51.93c16.51-16.51,36.57-18.37,52.74-13.08c1.16,0.38,2.16,2.87,3.31,3.09 c15.24,2.87,21.44,19.45,14.84,17.56c-3.09-0.88-6.85-1.43-9.83-1.1c-1.13,0.12-2.7,2.3-3.98,2.48c-1.98,0.28-6.8,0.55-9.18,0.79 c-23.59,2.36-31.93,17.96-33,36.72c-0.12,2.08-1.59,1.6-1.88,3.3c-0.89,5.13,2.8,12.58,4.56,17.88 C97.91,156.96,97.97,159.94,92.25,158.32"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M78.78,84.71c-14.7,14.7-13.88,35.91-7.46,51.93c0.42,1.06,2.79,1.79,3.26,2.79 c3.86,8.3,11.94,17.27,17.67,18.89c5.72,1.62,5.66-1.36,4.12-5.98c-1.76-5.29-5.45-12.74-4.56-17.87c0.29-1.7,1.76-1.22,1.88-3.3 c1.07-18.77,9.41-34.36,33-36.72c2.38-0.24,7.2-0.5,9.18-0.78c1.27-0.18,2.85-2.35,3.97-2.48c2.98-0.33,6.74,0.22,9.83,1.1 c6.6,1.89,0.4-14.69-14.84-17.56c-1.16-0.22-2.15-2.71-3.31-3.08c-5.27-1.73-10.78-2.62-16.33-2.64 C102.98,69,90.06,73.44,78.78,84.71"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M132.08,70.41c2.65,5.74,7.44,15.9,3.57,24.63c-3.87,8.73,1.69,2.98,3.75-0.55 c2.65-4.53,0.43-17.08-5.45-23.42C128.25,64.92,131.94,70.11,132.08,70.41 M71.38,138.77c3.97-3.76,8.48-10.05,22.95-6.63 c16.79,3.98,7.09,4.97,0.46,3.87c-6.63-1.11-15.79,0.88-21.75,5.08C67.07,145.29,71.38,138.77,71.38,138.77 M64.75,112.71 c7.84-5.08,19.77-10.38,42.52,2.1c21.65,11.87,1.11-16.01-7.29-18c-8.39-1.99-26.61-8.62-33.46-2.32 C59.67,100.78,64.75,112.71,64.75,112.71"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M67.7,105.52c-2.46-8.38,0.98-32.51,32.51-38.42c5.49,0,26.1,3.28,16.81,41.88c-1.44,5.99-4.63,7.06-9.18,4.13 C97.22,106.29,77.97,94.83,67.7,105.52"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPastryProducts);
export default __webpack_public_path__ + "static/media/Pastry_products.33ab2f821b1164836dd857fde87b0209.svg";
export { ForwardRef as ReactComponent };